import { Ellipsis } from "lucide-react";

import { Button } from "../../v2/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../v2/dropdown-menu";

import { Action } from "@/types/table/action";

interface ActionsCellProps {
  actions: Action[];
}

export const ActionsCell = ({ actions }: ActionsCellProps) => {
  if (actions.length === 0) return null;

  const handleActionClick = (action: Action) => {
    action.onClick();
  };

  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <Ellipsis className="size-6" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {actions.map((action) => (
            <DropdownMenuItem
              key={action.key}
              variant={action.type === "negative" ? "destructive" : "default"}
              disabled={action.disabled}
              onClick={() => handleActionClick(action)}
            >
              {action.icon}
              {action.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
